import type {ReactAction} from '@netx/core/bootstrap';
// TODO: because appRouter is a backbone object (and our globals / recusrsive imports are not working), we need to import it from the core-next package
// if we import any deeper it will cause tests to fail... good times
import {appRouter} from '@netx/core-next';
import {faLink} from '@fortawesome/pro-solid-svg-icons';
import {canViewShareLinks} from '../enablers/canViewShareLinks';
import {ShareLinksLabel} from '../locales';

export const shareLinkActionLinksRouteIcon = faLink;

/**
 * Route to share links
 * @param params
 * @returns Action
 */
export const shareLinkActionLinksRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'share-links-route',
	cb: () => appRouter.navigate('share/tokens', true),
	enableTest: () => canViewShareLinks(),
	icon: shareLinkActionLinksRouteIcon,
	label: ShareLinksLabel.ROUTE,
	routeMatch: /^share\/tokens(\/?)/,
	...params,
});
